import React, { useMemo } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { usePortal } from "../../../../../Providers/PortalProvider";
import { usePictureSets } from "../../../../hooks/usePictureSets";
import {
  PhotographerOrSubjectListWrapper,
  StyledSubjectYearListHeader,
  SubjectListItem,
  SubjectYearListHeader,
} from "../../../../Components/Checkout/SubjectSelector";
import { useTranslation } from "react-i18next";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";

export default ({
  onClose,
  onSetSourceType,
  sourceType,
  allowSubjectChange,
}) => {
  const portal = usePortal();
  const { allowOwnPhotos } = portal.options;

  // Hardware/browser back closes the dialog instead of navigating away.
  useDialogBackButton(true, onClose);

  const {
    currentPictureSet,
    pictureSets: ps,
    setCurrentPictureSet,
  } = usePictureSets();
  const { t } = useTranslation();

  // FIXME: This must support package settings
  const pictureSets = useMemo(() => {
    console.log("Allow subject change: " + allowSubjectChange);
    let pictureSets = [...ps];

    if (portal.options.whiteLabelDisableMixPhotographers) {
      pictureSets = pictureSets.filter(
        (pictureSet) =>
          pictureSet?.photographer.uuid == currentPictureSet.photographer.uuid,
      );
    }
    // No subject change limits:
    else if (!allowSubjectChange) {
      return ps;
    }

    return pictureSets.map((pictureSet) => {
      // Change not allowed:
      let disabled = false;
      if (
        allowSubjectChange == 1 &&
        pictureSet.subject.uuid != currentPictureSet.subject.uuid
      ) {
        disabled = true;
      }
      // Allow if it's the same job:
      else if (
        allowSubjectChange == 2 &&
        pictureSet.job.uuid != currentPictureSet.job.uuid
      ) {
        disabled = true;
      }
      // Allow if it's the same job type:
      else if (
        allowSubjectChange == 3 &&
        pictureSet.jobType.uuid != currentPictureSet.jobType.uuid
      ) {
        disabled = true;
      }

      return {
        ...pictureSet,
        disabled,
      };
    });
  }, []);

  console.log("Mapped subjects", pictureSets);

  const handleSubjectChange = (pictureSet) => {
    setCurrentPictureSet(pictureSet);
    onSetSourceType("picture-set");
    onClose(true);
  };

  const handleSetSourceTypeRecentImages = () => {
    onSetSourceType("recent-images");
    onClose(true);
  };

  return (
    <Dialog open={true} fullWidth={true} onClose={onClose}>
      <DialogContent>
        <PhotographerOrSubjectListWrapper
          currentImageSet={sourceType == "picture-set" && currentPictureSet}
          imageSets={pictureSets}
          inDropDown={false}
          onChangeImageSet={handleSubjectChange}
        />
        {allowOwnPhotos && (
          <>
            <SubjectYearListHeader header={t("Add pictures")} />
            <SubjectListItem
              disabled={false}
              singleLabel={t("Upload own pictures")}
              icon="file_upload"
              onChangeImageSet={handleSetSourceTypeRecentImages}
              selectable={true}
              isSelected={sourceType == "recent-images"}
            />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
